import React from 'react';
import { Button, Flex, IconButton } from '@chakra-ui/react';
import { FaTrash } from 'react-icons/fa6';

import { Dialog } from '.';

export type ConfirmRemoveDialogProps = {
  text: string;
  buttonText?: string;
  onRemove: () => void;
};

export function ConfirmRemoveDialog(props: ConfirmRemoveDialogProps) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onRemove = () => {
    props.onRemove();
    setOpen(false);
  };

  return (
    <div>
      <IconButton color="secondary" onClick={handleClickOpen} aria-label="remove">
        <FaTrash />
      </IconButton>
      <Dialog
        width='sm'
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        actions={<Flex gap={6} >
          <Button onClick={handleClose} variant='ghost'>
            Отмена
          </Button>
          <Button onClick={onRemove} colorScheme="brand">
            {props.buttonText || 'Удалить'}
          </Button>
        </Flex>}
      >
        {props.text}
      </Dialog>
    </div>
  );
}
